<template>
  <div class="header">
      <div class="wrapper">
        <div class="logo">
          <img :src="require('@/assets/images/logo.png')" alt="" />
        </div>
        <div class="header-operation">
            <a class="to-link" href="https://wapp.feibu56.com/#/service-page/download" target="_blank">飞布达APP</a>
          <span class="spec"> | </span>
          <!-- <span class="to-link"></span> -->
          <a class="to-link" href="https://member.feibu56.com/" target="_blank">物流商登录</a>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'commonHeader'
}
</script>

<style lang="postcss" scoped>
.header {
  height: 80px;
  background-color: #fff;
}
.header .wrapper {
  position: relative;
  height: 100%;
}
.header .logo {
  padding-top: 16px;
  float: left;
}

.header .header-operation {
  position: absolute;
  top: 50%;
  margin-top: -10px;
  right: 0;
}
.to-link {
  cursor: pointer;
  color:#474747;
  text-decoration:none;
}

.header .qrcode {
  position:absolute;
  z-index: 1000;
  top: 26px;
  right: 150px;
  width: 200px;
  height: 200px;
  max-width: none;
  transform: scale(0);
  transform-origin: top right;
  opacity: 0;
  border-radius: 10px;
}

.to-link:hover{
  color: #409eff;
}

<!-- .to-link:hover .qrcode {
  transform: scale(1) !important;
  opacity: 1 !important;
  -webkit-transition: all .4s ease-in-out;
  -o-transition: all .4s ease-in-out;
  transition: all .4s ease-in-out;
} -->

.header .qrcode img{
  width: 196px;
  height: 196px;
  border-radius: 10px;
}

.qrcode:before {
  content: "";
  position: absolute;
  left: 63px;
  top: -5px;
  display: block;
  width: 10px;
  height: 10px;
  z-index: 1;
  background-color: #fff;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  border-color: #fff transparent transparent #fff;
}

.spec {
  color: #bbb;
  margin: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue